import styled from 'styled-components';

import { gridSizes, textSizes, zIndexses } from 'utils/style';

import Calendar from 'components/Calendar/container';

const higherPriceIndicator = `
  content: '';
  position: absolute;
  width: 0;
  height: 0 !important;
  border-style: solid;
  border-width: 0 7px 7px 0;
  border-color: transparent;
`;

export default styled(Calendar)`
  .DayPicker {
    display: inline-block;
  }

  .DayPicker-wrapper {
    position: relative;
    flex-direction: row;
    user-select: none;
  }

  .DayPicker-Months {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .DayPicker-Month {
    display: table;
    border-spacing: 0;
    border-collapse: collapse;
    user-select: none;
  }

  .DayPicker-NavButton {
    position: absolute;
    top: 6px;
    right: 0;
    left: auto;

    display: inline-block;
    width: 20px;
    height: 20px;
    background-position: center;
    background-size: 50%;
    background-repeat: no-repeat;
    color: var(--grey500);
    cursor: pointer;
  }

  .DayPicker-NavButton:hover {
    opacity: 0.8;
  }

  .DayPicker-NavButton--prev {
    left: 0;
    right: auto;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAVVJREFUWAnN2G0KgjAYwPHpGfRkaZeqvgQaK+hY3SUHrk1YzNLay/OiEFp92I+/Mp2F2Mh2lLISWnflFjzH263RQjzMZ19wgs73ez0o1WmtW+dgA01VxrE3p6l2GLsnBy1VYQOtVSEH/atCCgqpQgKKqYIOiq2CBkqtggLKqQIKgqgCBjpJ2Y5CdJ+zrT9A7HHSTA1dxUdHgzCqJIEwq0SDsKsEg6iqBIEoq/wEcVRZBXFV+QJxV5mBtlDFB5VjYTaGZ2sf4R9PM7U9ZU+lLuaetPP/5Die3ToO1+u+MKtHs06qODB2zBnI/jBd4MPQm1VkY79Tb18gB+C62FdBFsZR6yeIo1YQiLJWMIiqVjQIu1YSCLNWFgijVjYIuhYYCKoWKAiiFgoopxYaKLUWOii2FgkophYp6F3r42W5A9s9OcgNvva8xQaysKXlFytoqdYmQH6tF3toSUo0INq9AAAAAElFTkSuQmCC');
  }

  .DayPicker-NavButton--next {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAXRJREFUWAnN119ugjAcwPHWzJ1gnmxzB/BBE0n24m4xfNkTaOL7wOtsl3AXMMb+Vjaa1BG00N8fSEibPpAP3xAKKs2yjzTPH9RAjhEo9WzPr/Vm8zgE0+gXATAxxuxtqeJ9t5tIwv5AtQAApsfT6TPdbp+kUBcgVwvO51KqVhMkXKsVJFXrOkigVhCIs1Y4iKlWZxB1rX4gwlpRIIpa8SDkWmggrFq4IIRaJKCYWnSgnrXIQV1r8YD+1Vrn+bReagysIFfLABRt31v8oBu1xEBttfRbltmfjgEcWh9snUS2kNdBK6WN1vrOWxObWsz+fjxevsxmB1GQDfINWiev83nhaoiB/CoOU438oPrhXS0WpQ9xc1ZQWxWHqUYe0I0qrKCQKjygDlXIQV2r0IF6ViEBxVTBBSFUQQNhVYkHIVeJAtkNsbQ7c1LtzP6FsObhb2rCKv7NBIGoq4SDmKoEgTirXAcJVGkFSVVpgoSrXICGUMUH/QBZNSUy5XWUhwAAAABJRU5ErkJggg==');
  }

  .DayPicker-NavButton--interactionDisabled {
    display: none;
  }

  .DayPicker-Caption {
    display: table-caption;
    text-align: center;
    background-color: var(--white-caniche);
    height: 32px;
  }

  .DayPicker-Caption > div {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .DayPicker-Weekdays {
    display: table-header-group;
    margin-top: 1em;
  }

  .DayPicker-WeekdaysRow {
    display: table-row;
  }

  .DayPicker-Weekday {
    display: table-cell;
    padding: ${gridSizes('S')};
    color: var(--grey700);
    font-size: ${textSizes('S')};
    text-align: center;
  }

  .DayPicker-Weekday abbr[title] {
    border-bottom: none;
    text-decoration: none;
  }

  .DayPicker-Body {
    display: table-row-group;
  }

  .DayPicker-Week {
    display: table-row;
  }

  .DayPicker-Day {
    display: table-cell;
    padding: 0 12px;
    vertical-align: middle;
    text-align: center;
    border: 1px solid var(--grey-mouse);
    cursor: pointer;
    width: 44px;
    height: ${gridSizes('XL')};
  }

  .DayPicker-WeekNumber {
    display: table-cell;
    padding: 0.5em;
    min-width: 1em;
    border-right: 1px solid #eaecec;
    color: #8b9898;
    vertical-align: middle;
    text-align: right;
    font-size: 0.75em;
    cursor: pointer;
  }

  .DayPicker--interactionDisabled .DayPicker-Day {
    cursor: default;
  }

  .DayPicker-Footer {
    padding-top: 0.5em;
  }

  .DayPicker-TodayButton {
    border: none;
    background-color: transparent;
    background-image: none;
    box-shadow: none;
    color: #4a90e2;
    font-size: 0.875em;
    cursor: pointer;
  }

  /* Default modifiers */

  .DayPicker-Day--today {
    background: var(--white-caniche);
  }

  .DayPicker-Day--outside {
    color: var(--grey-mouse);
    border: 0;
    cursor: default;
  }

  .DayPicker-Day--disabled {
    color: var(--grey-mouse);
    cursor: default;
    pointer-events: none;
  }

  /* Example modifiers */

  .DayPicker-Day--sunday {
    background-color: #f7f8f8;
  }

  .DayPicker-Day--sunday:not(.DayPicker-Day--today) {
    color: #dce0e0;
  }

  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
    position: relative;
    background-color: var(--primary100);
    &:after {
      content: '';
      position: absolute;
      box-shadow: inset 0 0 0 2px var(--primary500);
      top: -1px;
      left: -1px;
      width: 45px;
      height: 41px;
    }
  }

  .DayPicker:not(.DayPicker--interactionDisabled)
    .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {
    position: relative;
    background-color: var(--primary100);
    &:after {
      content: '';
      position: absolute;
      box-shadow: inset 0 0 0 1px var(--primary300);
      top: -1px;
      left: -1px;
      width: 45px;
      height: 41px;
    }
  }

  .DayPicker-Day--higherPriceWeekend,
  .DayPicker-Day--higherPriceToday {
    position: relative;
    &:not(.DayPicker-Day--outside) {
      &::before {
        ${higherPriceIndicator}
        border-right-color: var(--error700);
        top: 0;
        right: 0;
      }
    }
  }

  /* DayPickerInput */

  .DayPickerInput {
    display: inline-block;
  }

  .DayPickerInput-OverlayWrapper {
    position: relative;
  }

  .DayPickerInput-Overlay {
    position: absolute;
    left: 0;
    z-index: ${zIndexses.dayPickerInputOverlay};

    background: white;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  }

  .calendar {
    &__footer-message {
      color: var(--grey700);
      &-higher-price {
        position: relative;
        p {
          margin-left: 1.6rem;
          margin-bottom: 0;
        }
        &:before {
          ${higherPriceIndicator}
          top: 0.4rem;
          left: 0;
          border-right-color: var(--error700);
        }
      }
    }
  }
`;
